import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Form, FormGroup, Label, Input
} from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';

import { userFormValidator } from 'utils/userFormValidate';
import { ROUTES } from 'constants/Routes.js';

import 'assets/scss/components/password.css';

const PasswordContainer = ({
  loading,
  handleSubmit,
  headerInstruction,
  buttonContent,
  children,
  forgotPassword,
}) => {
  const loggingIn = loading ? <FontAwesomeIcon icon="spinner" pulse /> : '';

  function validateUserForm(event) {
    const result = userFormValidator(event);
    if (result) handleSubmit(event);
  }

  const buttonContainer = forgotPassword ? (
    <div>
      <NavLink className="forgot-password text-muted" to={ROUTES.PASSWORD_RESET}>
        Forgot your password?
      </NavLink>
      <Button type="button" className="login-btn" onClick={validateUserForm.bind(this)}>
        {loggingIn}
        {buttonContent}
      </Button>
    </div>
  ) : (
      <Button type="button" className="login-btn" onClick={validateUserForm.bind(this)}>
        {loggingIn}
        {buttonContent}
      </Button>
    );

  return (
    <div className="reset-password-container" id="userForm">
      <Form className="reset-password-form" id="form-validate">
        <div className="header-instructions mb-3">{headerInstruction}</div>
        {children}
        {buttonContainer}
      </Form>
    </div>
  );
};

PasswordContainer.defaultProps = {
  forgotPassword: false,
  headerInstruction: ''
};

PasswordContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  headerInstruction: PropTypes.string,
  buttonContent: PropTypes.string.isRequired,
  children: PropTypes.shape({}).isRequired,
  forgotPassword: PropTypes.bool
};

export default PasswordContainer;



// WEBPACK FOOTER //
// ./src/components/users/Password.js